var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import logoBlackImage from './assets/mailship/logo_black.png';
import logoMImage from './assets/mailship/logo_m.png';
import logoWhiteImage from './assets/mailship/logo_white.png';
import logoSvg from './assets/mailship/mailship-logo.svg';
import logoMailstepBlack from './assets/mailstep/mailstep_black.svg';
import logoMailstepWhite from './assets/mailstep/mailstep_white.svg';
import logoMailstock from './assets/mailstock/mailstock.svg';
import logoMailwise from './assets/mailwise/mailwiseLogo.svg';
import logoMailwiseSmall from './assets/mailwise/mailwiseLogoSmall.svg';
import logoMailwrap from './assets/mailwrap/mailwrapLogo.svg';
import warehouseManager2 from './assets/warehouse/manager2.svg';
import warehouseManager3 from './assets/warehouse/manager3.svg';
import warehouseManager from './assets/warehouse/manager.svg';
import styled from '@xstyled/styled-components';
var defaultSizes = {
    small: '30px',
    medium: '46px',
    big: '61px' // cca 200px width on full logo
};
var variantMap = {
    mailship: {
        white: logoWhiteImage,
        black: logoBlackImage,
        m: logoMImage,
        s: logoSvg
    },
    mailwise: {
        black: logoMailwise,
        s: logoMailwiseSmall
    },
    mailstock: {
        black: logoMailstock
    },
    mailstep: {
        black: logoMailstepBlack,
        white: logoMailstepWhite
    },
    mailwrap: {
        black: logoMailwrap
    },
    warehouse: {
        black: warehouseManager,
        m: warehouseManager2,
        s: warehouseManager3
    }
};
var StyledImage = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n"], ["\n  width: ", ";\n  height: ", ";\n"])), function (_a) {
    var width = _a.width;
    return width || 'auto';
}, function (_a) {
    var height = _a.height, width = _a.width, size = _a.size;
    return height || (width ? 'auto' : size ? defaultSizes[size] : defaultSizes['medium']);
});
var Logo = function (_a) {
    var _b = _a.brand, brand = _b === void 0 ? 'mailship' : _b, variant = _a.variant, size = _a.size, width = _a.width, height = _a.height, rest = __rest(_a, ["brand", "variant", "size", "width", "height"]);
    var variants = variantMap[brand];
    var logo = variants === null || variants === void 0 ? void 0 : variants[variant];
    if (!logo) {
        console.warn('No variant for this logo exists.');
        return null;
    }
    return _jsx(StyledImage, __assign({ src: logo, size: size, width: width, height: height }, rest));
};
export default Logo;
var templateObject_1;
